const getWeddingsOfUserAsHost = userWeddings =>
  userWeddings
    .filter(wedding => wedding.r === 'BRIDE' || wedding.r === 'GROOM')
    .map(wedding => {
      return { r: wedding.r, w: wedding.w.substring(6) };
    });
export default getWeddingsOfUserAsHost;
